import React, { useState } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import * as XLSX from 'xlsx';
// import { fetchObjects } from '../client';

const ExampleComponent: React.FC = () => {
  const [data, setData] = useState<any[]>([]);

  // Function to handle file upload and parse Excel data
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const binaryStr = e.target?.result;
      if (binaryStr) {
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheetName = workbook.SheetNames[0]; // Get the first sheet
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet); // Convert sheet to JSON
        setData(jsonData as any[]);
      }
    };
    reader.readAsBinaryString(file);
  };

  const fetchData = async () => {
    // await fetchObjects();
  };

  return (
    <div style={{ width: '100%', height: 500 }}>
      <button onClick={fetchData}>SDK</button>
      <h2>Inventory Value Report</h2>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      {data.length > 0 ? (
        <ResponsiveContainer>
          <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="Month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="Owned On Hand Qty" stroke="#8884d8" name="Owned Quantity" />
            <Line type="monotone" dataKey="Owned Inv Value" stroke="#82ca9d" name="Owned Inventory Value" />
            <Line type="monotone" dataKey="Consigned On Hand Qty" stroke="#ffc658" name="Consigned Quantity" />
            <Line type="monotone" dataKey="Consigned Inv Value" stroke="#ff7300" name="Consigned Inventory Value" />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <p>Please upload an Excel file to display the chart.</p>
      )}
    </div>


  );
};

export default ExampleComponent;